import { cn } from "@/shared/lib/utils";

interface ProgressBarProps {
  value: number;
  max: number;
  label?: string;
  showCount?: boolean;
  className?: string;
  testId?: string;
}

/** Jednoduchý horizontální progress bar — primary výplň na slate tracku. */
export function ProgressBar({
  value,
  max,
  label,
  showCount = true,
  className,
  testId,
}: ProgressBarProps) {
  const safeMax = Math.max(max, 1);
  const clamped = Math.max(0, Math.min(value, safeMax));
  const pct = Math.round((clamped / safeMax) * 100);

  return (
    <div className={cn("flex w-full flex-col gap-1", className)} data-testid={testId}>
      {label || showCount ? (
        <div className="flex items-center justify-between text-xs text-muted-foreground">
          {label ? <span>{label}</span> : <span />}
          {showCount ? (
            <span className="tabular-nums">
              {clamped}/{max}
            </span>
          ) : null}
        </div>
      ) : null}
      <div className="h-2 w-full overflow-hidden rounded-full bg-muted" aria-hidden="true">
        <div
          className="h-full rounded-full bg-primary transition-[width]"
          style={{ width: `${pct}%` }}
        />
      </div>
      <span className="sr-only">
        {label ? `${label}: ` : ""}
        {clamped} z {max}
      </span>
    </div>
  );
}
